import { CxViewFilter } from './cx-performance.state';

/**
 * get reports for customer service
 */
export class GetCXReports {
    static readonly type = '[Report] GetCXReports';
    constructor(public currentView: CxViewFilter, public user: object, public autoRefresh: boolean) { }
}

/**
 * get more groups by team
 */
 export class GetMoreTeamsToDisplay {
    static readonly type = '[Map] GetMoreTeamsToDisplay';
    constructor(public currentView: CxViewFilter, public numberOfTeams: number) { }
}
